import { RewardsLevel } from '../../graphql/search'

export interface RewardsLevelInfo {
  level: RewardsLevel
  salesThreshold: {
    minimum: number
    maximum?: number
  }
  benefits: {
    vipDiscountPercentage: number
    commissionsPercentage: number
    rebatePercentage: number
  }
}

export const rewardsLevels = [
  RewardsLevel.Level_1,
  RewardsLevel.Level_2,
  RewardsLevel.Level_3,
  RewardsLevel.Level_4,
  RewardsLevel.Level_5,
  RewardsLevel.Level_6,
]

export const tierFromRewardsLevel = (level: RewardsLevel) =>
  rewardsLevels.indexOf(level) + 1 || null

export const nextRewardsLevel = (level: RewardsLevel) =>
  rewardsLevels[rewardsLevels.indexOf(level) + 1] || null

export const rewardsLevelsInfo: RewardsLevelInfo[] = [
  {
    level: RewardsLevel.Level_1,
    salesThreshold: {
      minimum: 0,
      maximum: 500,
    },
    benefits: {
      vipDiscountPercentage: 0,
      rebatePercentage: 0,
      commissionsPercentage: 35,
    },
  },
  {
    level: RewardsLevel.Level_2,
    salesThreshold: {
      minimum: 500,
      maximum: 1500,
    },
    benefits: {
      vipDiscountPercentage: 5,
      rebatePercentage: 5,
      commissionsPercentage: 40,
    },
  },
  {
    level: RewardsLevel.Level_3,
    salesThreshold: {
      minimum: 1500,
      maximum: 3500,
    },
    benefits: {
      vipDiscountPercentage: 7.5,
      rebatePercentage: 7.5,
      commissionsPercentage: 45,
    },
  },
  {
    level: RewardsLevel.Level_4,
    salesThreshold: {
      minimum: 3500,
      maximum: 5500,
    },
    benefits: {
      vipDiscountPercentage: 10,
      rebatePercentage: 10,
      commissionsPercentage: 47.5,
    },
  },
  {
    level: RewardsLevel.Level_5,
    salesThreshold: {
      minimum: 5500,
      maximum: 8000,
    },
    benefits: {
      vipDiscountPercentage: 12.5,
      rebatePercentage: 12.5,
      commissionsPercentage: 50,
    },
  },
  {
    level: RewardsLevel.Level_6,
    salesThreshold: {
      minimum: 8000,
    },
    benefits: {
      vipDiscountPercentage: 15,
      rebatePercentage: 15,
      commissionsPercentage: 50,
    },
  },
]

export const rewardsLevelInfo = (level: RewardsLevel) =>
  rewardsLevelsInfo.find((info) => info.level === level)

export const maxVipDiscountPercentage = rewardsLevelsInfo.reduce(
  (max, { benefits }) => Math.max(max, benefits.vipDiscountPercentage),
  0,
)

export const maxRebatePercentage = rewardsLevelsInfo.reduce(
  (max, { benefits }) => Math.max(max, benefits.rebatePercentage),
  0,
)
